import React from 'react';
import { motion } from 'framer-motion';
import impactResultImage from '../../../assets/images/arbventure/impact_result.webp';
import Constants from '../../../app/utils/constants';
import colors from '../../theme/color';

const ImpactResultsSection = () => {
  const { arbventureImpactResults } = Constants;

  return (
    <section className="relative overflow-hidden pb-10 pt-8 md:pb-16 md:pt-10 lg:pb-20 2xl:pb-24">
      <div className="mx-auto w-full px-5 text-center md:px-8 lg:px-12 xl:max-w-[1320px] 2xl:max-w-[85%] 2xl:px-16">

        {/* BADGE — slides up + continuously pulses */}
        <div
        >
          <motion.div
            className="inline-flex items-center justify-center px-6 py-3 lg:px-7 lg:py-3.5 2xl:px-9 2xl:py-4 min-[2560px]:px-12 min-[2560px]:py-6"
            style={{ backgroundColor: colors.arbVentureAccent }}
          >
            <span className="font-gilroy-bold text-[2rem] font-semibold leading-none text-white lg:text-[2.35rem] xl:text-[2.7rem] 2xl:text-[3.25rem] min-[2056px]:text-[3.8rem] min-[2560px]:text-[4.8rem]">
              {arbventureImpactResults.badgeText}
            </span>
          </motion.div>
        </div>

        {/* DESCRIPTION — slides up from bottom */}
        <motion.p
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.3 }}
          transition={{ duration: 0.7, ease: 'easeOut', delay: 0.15 }}
          className="mx-auto mt-5 font-gilroy-medium opacity-[80%] text-[1.05rem] leading-[1.5] md:text-[1.16rem] lg:max-w-[90%] lg:text-[1.24rem] xl:text-[1.34rem] 2xl:max-w-[85%] 2xl:text-[1.72rem] min-[2560px]:max-w-[1500px] min-[2560px]:text-[2.6rem] min-[2560px]:mt-10"
          style={{ color: colors.arbVentureTextMuted }}
        >
          {arbventureImpactResults.description}
        </motion.p>
      </div>

      {/* IMAGE BLOCK — slides up from bottom */}
      <motion.div
        initial={{ opacity: 0, y: 80 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.2 }}
        transition={{ duration: 0.8, ease: 'easeIn', delay: 0.25 }}
        className="relative mt-10 h-[220px] w-full overflow-hidden md:mt-12 md:h-[270px] lg:h-[320px] xl:h-[360px] 2xl:h-[460px] min-[2560px]:h-[700px] min-[2560px]:mt-20"
      >
        <img
          src={impactResultImage}
          alt="Team collaboration representing ARB Venture impact"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-[rgba(20,55,16,0.22)]" />
        <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(11,13,11,0.08)_0%,rgba(11,13,11,0.18)_100%)]" />

        <div className="relative z-10 mx-auto flex h-full  items-center justify-center px-6 md:px-10 lg:max-w-[1100px] 2xl:max-w-[1880px] min-[2560px]:max-w-[1800px]">
          {/* IMAGE TEXT — slides up with slight extra delay */}
          <p
            className=" text-center font-gilroy-semibold opacity-75 text-[1.1rem] leading-[1.4] md:text-[1.3rem] lg:max-w-[820px] lg:text-[1.5rem] xl:text-[1.7rem] 2xl:max-w-[1600px] 2xl:text-[2rem] min-[2560px]:max-w-[1400px] min-[2560px]:text-[3.2rem]"
          >
            {arbventureImpactResults.imageText}
          </p>
        </div>
      </motion.div>
    </section>
  );
};

export default ImpactResultsSection;